import Vue from 'vue'
import _ from 'lodash'

const Config = {}
Config.api_server = 'http://rechner-api.localhost:8080'
//import stackTrace from  'stacktrace-js'

const storeModule_Session = {
  state: {
    api_url: '',
    currentLocation: window.location.pathname,
    base64_envelope: null,
  },
  mutations: {
    session_setApiServer: function (state, payload) {
      state.api_url = payload.url
    },
    session_set_envelope: function (state, payload) {
      state.base64_envelope = payload.data
    },
    session_setUser: function (state, payload) {
      state.user = payload.data
    },

  },
  actions: {
    /*
     session_resume(storeCtx, payload) {
     const sid = localStorage.getItem("session_id") == null ? "" : localStorage.getItem("session_id");
     storeCtx.commit('session_setLastUser', {name: localStorage.getItem("lastUser") });

     storeCtx.commit('open_watingModal');
     Vue.http.get(storeCtx.state.api_url,
     {params: {command: 'getCurrentSession', sid: sid}}
     ).then((response) => {
     console.log("@@@@@@@@@@@", response);
     storeCtx.commit('close_watingModal');
     if (response.data.status == "success") {
     console.log("API: %cSession resumed - success for %c" + response.data.request_was.command, "background-color:#adffa5;color:#246020;font-weight:normal;", "background-color:#adffa5;font-weight:bold;font-family:Arial;");
     storeCtx.commit('session_setUser', {user: response.data.user});
     } else if(sid>'') {
     console.log("API: %cSession not found - no success for %c" + response.data.request_was.command, "background-color:#fcd077;color:#be8383,font-weight:normal;", "background-color:#fcd077;color:#ba0000;font-weight:bold;font-family:Arial;");
     storeCtx.commit('open_infoModal', {
     header: "Info:",
     text: "Die letzte Sitzung konnte nicht fortgesetzt werden \n bitte neu anmelden"
     });
     }
     storeCtx.commit('session_setUserList', {userList: response.data.userList});
     payload.onFinish();
     }, (response) => {
     console.log("API: %cError during API-Request ", "background-color:red;color:yellow", response);
     storeCtx.commit('close_watingModal');
     storeCtx.commit('open_ApiErrorModal');
     payload.onFinish();
     });

     },//___________________________________________________________________________________________________________
     */
    session_setLocation: function (storeCtx, payload) {
      console.log('store.session_setLocation - referrer: ', payload.referrer)
      console.log('rootstate', storeCtx.rootState)
      storeCtx.state.currentLocation = payload.newLocation
      if (payload.referrer === 'VLink') {
        window.history.pushState(
          null,
          storeCtx.rootState.routes[payload.newLocation].Page,
          payload.newLocation
        )
      }
    }, //___________________________________________________________________________________________________________

    sendApiRequest (storeCtx, payload) {

      /*
       stackTrace.get().then(function (stack) {
       // for (var index in stack) {  console.log(index + ") " + stack[index].toString())}
       const caller = stack[4];
       console.log("request called from %c" + caller.functionName + "()%c in File %c" + caller.fileName.replace('webpack:///', '') + "%c at Line %c" + caller.lineNumber, "font-weight:bold;", "font-weight:normal;", "font-weight:bold;", "font-weight:normal;", "font-weight:bold;");
       });
       */
      console.log('request.....', payload)
      const sid = sessionStorage.getItem('session_id') == null ? '' : sessionStorage.getItem('session_id')

      storeCtx.commit('open_watingModal')

      var referrer = window.document.referrer
      var a = document.createElement('a')
      a.href = referrer
      var referrer_doamin = a.hostname
      var body = null
      var data = null
//------------------------------------------------------------------
      if (payload.files) {
        const formData = new FormData()
        formData.append('command', payload.command)
        formData.append('referrer', referrer_doamin)
        formData.append('args', JSON.stringify(payload.args))
        formData.append('sid', sid)
        if (payload.files) {
          Array
            .from(Array(payload.files.length).keys())
            .map(x => {
              console.log('files:', x, payload.files[x].name)
              formData.append('files[]', payload.files[x], payload.files[x].name)
            })
        }
        data = formData
      } else {
        data = {
          command: payload.command,
          referrer: referrer_doamin,
          args: payload.args,
          sid: sid,
          test: 'moep',
        }
      }
      //------------------------------------------------------------------

      if (!payload.method || payload.method === 'post') {
        var method = 'post'
        body = data
        var params = ''

      } else {
        var method = 'get'
        var params = data
        body = ''
      }


       var req =     {
         url: storeCtx.state.api_url,
         method: method,
         emulateJSON: true,
         headers: {'Content-Type': 'application/json'},
         responseType: 'json',
         body: body,
         params: params,
         progress: function (event) {
           //console.log('progress event: (' + event.loaded + ' / ' + event.total + ')', event)
           if (typeof(payload.onProgress) === 'function') {
             payload.onProgress(event)
           }

         }

       }
      console.log("## JJ332 ###", method)
      console.log("## JJ333 ###", req)
      //------------------------------------------------------------------
      var test = Vue.http(
      req
      ).then((response) => {
        console.log('######', response)
        storeCtx.commit('close_watingModal')
        if (response.data) {
          if (response.data.status === 'success') {

            console.log('API: %cSuccess of Command %c' + payload.command, 'background-color:#adffa5;color:#246020;font-weight:normal;', 'background-color:#adffa5;font-weight:bold;font-family:Arial;')
            payload.onSuccess(response)
          } else {
            console.log('API: %cError during Command %c' + payload.command, 'background-color:#fcd077;color:#be8383,font-weight:normal;', 'background-color:#fcd077;color:#ba0000;font-weight:bold;font-family:Arial;')
            if (typeof(payload.onError) === 'function') {
              payload.onError(response)
            }
          }
        } else {
          console.log('API: %cError on Server during Command %c' + payload.command, 'background-color:#fcd077;color:#be8383,font-weight:normal;', 'background-color:#fcd077;color:#ba0000;font-weight:bold;font-family:Arial;')
          if (typeof(payload.onError) === 'function') {
            payload.onError(response)
          }
        }
      }, (response) => {
        console.log('API: %cHTTP-Error during Request for Command %c' + payload.command, 'background-color:red;color:yellow', response)
        storeCtx.commit('close_watingModal')
        storeCtx.commit('open_ApiErrorModal')
        response.data.status = 'error'
        response.data.error = 'XHR-error'
        payload.onError(response)
      })
      console.log('XHR ? :', test)
    }, //___________________________________________________________________________________________________________

  }
}
/*####################################################################################################################################################################*/

export default {
  state: {
    rechnerStatus: 'inputing data',

    rechnerConfig: {
      loaded: false,
      rechnerInfo: {},
      fieldDefs: {}
    },
    tarife: {},
    leistungen: {},
    tarifeFootnotes: {},
    show_waitingModal: false,
    show_infoModal: false,
    testData: {},

    infoHeader: 'A',
    infoText: 'B',
    isPage: {},

  },
  getters: {
    subDomain: function () {
      var parts = window.location.hostname.split('.')
      if (parts[parts.length - 1].length <= 4) parts.pop()
      parts.pop()
      var subDomain = parts.join('.')
      return subDomain
    },
    rootDomain: function () {
      var parts = window.location.hostname.split('.')
      var domainParts = []
      if (parts[parts.length - 1].length <= 4) domainParts.push(parts.pop())
      domainParts.unshift(parts.pop())
      var rootDomain = domainParts.join('.')
      return rootDomain
    },

  },
  mutations: {
    set_rechnerStatus: function (state, payload) {
      state.rechnerStatus = payload.data
    },
    set_rechnerConfig: function (state, payload) {
      state.rechnerConfig = payload.data
    },
    add_FieldDef: function (state, payload) {
      state.rechnerConfig.fieldDefs[payload.data.name] = payload.data
    },
    remove_FieldDef: function (state, payload) {
      _.unset(state.rechnerConfig.fieldDefs, payload.data)
    },
    set_testDaten: function (state, payload) {
      state.testData = payload.data
    },
    set_tarife: function (state, payload) {
      state.tarife = payload.data
    },
    set_leistungen: function (state, payload) {
      state.leistungen = payload.data
    },
    set_tarifeFootnotes: function (state, payload) {
      state.tarifeFootnotes = payload.data
    },
    open_watingModal: function (state) {
      state.show_waitingModal = true
    },
    close_watingModal: function (state) {
      state.show_waitingModal = false
    },
    open_infoModal: function (state, payload) {
      state.show_infoModal = true
      state.infoHeader = payload.header
      state.infoText = payload.text
    },
    close_infoModal: function (state, payload) {
      state.show_infoModal = false
      state.infoHeader = ''
      state.infoText = ''
    },
    open_ApiErrorModal: function (state, payload) {
      state.show_infoModal = true
      state.infoHeader = 'Achtung: Verbindungs-Probleme'
      state.infoText = 'Es kam nicht die erwartete Antwort vom Server'
    },
    close_ApiErrorModal: function (state, payload) {
      state.show_infoModal = false
      state.infoHeader = ''
      state.infoText = ''
    },

  },
  modules: {
    session: storeModule_Session
  }
}
